var map = {
	"./featured-blogs.de-CH.json": 1380,
	"./featured-blogs.de-DE.json": 1381,
	"./featured-blogs.en-CA.json": 1382,
	"./featured-blogs.en-GB.json": 1383,
	"./featured-blogs.en-IN.json": 1384,
	"./featured-blogs.en-ME.json": 1385,
	"./featured-blogs.en-US.json": 1386,
	"./featured-blogs.es-EM.json": 1387,
	"./featured-blogs.es-ES.json": 1388,
	"./featured-blogs.fr-BE.json": 1389,
	"./featured-blogs.fr-CA.json": 1390,
	"./featured-blogs.fr-CH.json": 1391,
	"./featured-blogs.nl-BE.json": 1392,
	"./featured-blogs.nl-NL.json": 1393,
	"./featured-blogs.pl-PL.json": 1394,
	"./featured-blogs.pt-BR.json": 1395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1379;